


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { Map } from "lucide-react"; // Professional Icon

// function PublicHeader() {
//   const navigate = useNavigate();

//   const styles = {
//     header: {
//       height: "70px",
//       backgroundColor: "#ffffff",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "0 60px", // More padding for a wide, premium feel
//       boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
//       position: "sticky",
//       top: 0,
//       zIndex: 1000,
//       borderBottom: "1px solid #f1f5f9"
//     },
//     logoContainer: {
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       cursor: "pointer",
//     },
//     logoBox: {
//       width: "40px",
//       height: "40px",
//       background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)", // Stylish Indigo Gradient
//       borderRadius: "12px",
//       color: "#fff",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)"
//     },
//     brandName: {
//       margin: 0,
//       fontSize: "22px",
//       fontWeight: "800",
//       letterSpacing: "-0.5px",
//       color: "#0f172a", // Deep Slate for professionalism
//       fontFamily: "'Inter', sans-serif"
//     },
//     accentText: {
//       color: "#4f46e5"
//     },
//     navLinks: {
//       display: "flex",
//       gap: "30px",
//       fontSize: "14px",
//       fontWeight: "600",
//       color: "#64748b" // Subtle gray
//     },
//     supportLink: {
//       cursor: "pointer",
//       transition: "0.2s",
//       ":hover": { color: "#4f46e5" }
//     }
//   };

//   return (
//     <div style={styles.header}>
//       {/* Stylish Logo & Brand */}
//       <div onClick={() => navigate("/")} style={styles.logoContainer}>
//         <div style={styles.logoBox}>
//           <Map size={24} strokeWidth={2.5} />
//         </div>

//         <h2 style={styles.brandName}>
//           Plot<span style={styles.accentText}>Management</span>
//         </h2>
//       </div>

//       {/* Navigation (Clean & Professional) */}
      

//       {/* Right side is intentionally clean now since Login is on the main page */}
//       <div style={{ width: "40px" }}></div> 
//     </div>
//   );
// }

// export default PublicHeader;

//below logo updated 

import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPinned } from "lucide-react";

function PublicHeader() {
  const navigate = useNavigate();

  const styles = {
    header: {
      height: "70px",
      backgroundColor: "#ffffff",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 60px",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      borderBottom: "1px solid #f1f5f9",
    },
    logoContainer: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer",
    },
    logoBox: {
      width: "40px",
      height: "40px",
      background: "linear-gradient(135deg, #e57e46 0%, #4d298b 100%)",
      borderRadius: "12px",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
    },
    brandName: {
      margin: 0,
      fontSize: "22px",
      fontWeight: "800",
      letterSpacing: "-0.5px",
      color: "#0f172a",
      fontFamily: "'Inter', sans-serif",
    },
  };

  return (
    <div style={styles.header}>
      {/* Logo & Brand */}
      <div onClick={() => navigate("/")} style={styles.logoContainer}>
        <div style={styles.logoBox}>
          <MapPinned size={22} strokeWidth={2.5} />
        </div>

        <h2 style={styles.brandName}>
          <span
            style={{
              textDecoration: "underline",
              textUnderlineOffset: "4px",
              textDecorationThickness: "2px",
            }}
          >
            Ma
          </span>
          g
          <span
            style={{
              color: "#56b06f",
              textDecoration: "underline",
              textUnderlineOffset: "4px",
              textDecorationThickness: "2px",
            }}
          >
            nets
          </span>
        </h2>
      </div>

      {/* Right side intentionally empty */}
      <div style={{ width: "40px" }}></div>
    </div>
  );
}

export default PublicHeader;